import React from "react";
import { Table, Button } from "react-bootstrap";
import { SalaryMaster } from "../types/salaryMaster";
import "../styles/EmployeeList.css";
import { Edit, Trash } from "lucide-react";

interface Props {
  list: SalaryMaster[];
  onEdit: (item: SalaryMaster) => void;
  onDelete: (id: number) => void;
}

const SalesMasterList: React.FC<Props> = ({ list, onEdit, onDelete }) => {
  return (
    <Table className="custom-employee-table" responsive>
      <thead>
        <tr>
          <th>Employee ID</th>
          <th>Basic Pay</th>
          <th>HRA</th>
          {/* <th>Tax</th> */}
          <th>PF</th>
          <th>TA</th>
          <th>SA</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {list.map((sal) => (
          <tr key={sal.id}>
            <td>{sal.employeeId}</td>
            <td>{sal.basicPay}</td>
            <td>{sal.hra}</td>
            {/* <td>{sal.tax}</td> */}
            <td>{sal.pf}</td>
            <td>{sal.ta}</td>
            <td>{sal.sa}</td>
            <td>
              <Button
                variant="success"
                onClick={() => onEdit(sal)}
                style={{
                  padding: "5px",
                  borderRadius: "5px",
                }}
                className="mr-2"
              >
                <Edit />
              </Button>
              <Button
                variant="danger"
                onClick={() => onDelete(sal.id)}
                style={{
                  padding: "5px",
                  borderRadius: "5px",
                }}
              >
                <Trash />
              </Button>
            </td>
          </tr>
        ))}
      </tbody>
    </Table>
  );
};

export default SalesMasterList;
